import React from 'react';
import { keyBy } from 'lodash';
import { useElementSize } from 'taboola-ultimate-ui/lib/src/hooks';
import { ChatAgentButtonBase } from 'components/ChatAgent/components/ChatAgentButtonBase/ChatAgentButtonBase';
import { CAMPAIGN_STATUS, ENTITY } from 'modules/campaigns/config';
import { PERFORMANCE_RECOMMENDATIONS } from 'modules/campaigns/modules/performance-recommendations/config/performanceRecommendations';
import { useRibbonRecommendation } from 'modules/campaigns/modules/performance-recommendations/hooks/useRibbonRecommendation';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import styles from './fixCampaignWithAiButton.module.scss';

const { CAMPAIGN_UNDERPERFORMING } = PERFORMANCE_RECOMMENDATIONS;
const FULL_MODE_WIDTH = 126;

export const FixCampaignWithAiButton = ({ campaignData, entityType }) => {
    const { width, ref: containerRef } = useElementSize();
    const { id } = campaignData;
    const { accountId } = useAccount();
    const { ribbonRecommendations } = useRibbonRecommendation(accountId);
    const recommendationsByCampaignId = keyBy(ribbonRecommendations, 'campaignId');
    const isPaused = campaignData.status === CAMPAIGN_STATUS.PAUSED || !campaignData.isActive;

    const isUnderperforming = recommendationsByCampaignId[id]?.type === CAMPAIGN_UNDERPERFORMING;
    const eventData = { recommendation: recommendationsByCampaignId[id] };
    const isCompactMode = width < FULL_MODE_WIDTH;

    if (!isUnderperforming || entityType !== ENTITY.CAMPAIGN || isPaused) {
        return null;
    }

    return (
        <div className={styles['container']} ref={containerRef} aria-label="Fix With Abby">
            <ChatAgentButtonBase
                eventData={eventData}
                id="CAMPAIGN_NOT_SERVING"
                agentName="campaign_underperforming"
                messageId="abby.underperforming.campaign"
                className={styles['button-container']}
                isCompactMode={isCompactMode}
            />
        </div>
    );
};
